import { Box } from '@mui/material'

import { TableLimit } from '@/@core/components/mui/TableLimit'
import { useRouteQuery, useTranslator } from '@/hooks'
import { SearchInput } from '../common/SearchInput'

export const EmployerContractHistoryFilter = () => {
  const { __ } = useTranslator()
  const { updateQuery, searchQuery } = useRouteQuery()

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
      }}
    >
      <TableLimit />

      <SearchInput
        placeholder={__('Search Contract File Name')}
        className='w-[245px]'
        onSearch={value => {
          updateQuery({ keyword: value, page: 1 })
        }}
        initialValue={searchQuery.get('keyword') || ''}
      />
    </Box>
  )
}
